import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons'
import { green, red } from '@ant-design/colors'
import { FC } from 'react'
import styled from 'styled-components'

const MoreIcon = styled(CaretUpFilled)`
    color: ${red[5]};
`

const LessIcon = styled(CaretDownFilled)`
    color: ${green[5]};
`

interface CostDiffIconProps {
    planned: number
    actual: number
}

/** Отклонение фактической стоимости от плановой: больше плана — красный ▲, меньше — зелёный ▼. */
const CostDiffIcon: FC<CostDiffIconProps> = ({ planned, actual }) => {
    if (actual === planned) return null
    return actual > planned ? <MoreIcon /> : <LessIcon />
}

export default CostDiffIcon
